import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  @media (max-width: ${({ theme }) => theme.breakpoints?.values['md']}px) {
    grid-template-columns: 1fr;
  }
`
